import { createReactComponent } from '@tabler/icons-react';

export const IconCustomChartsWaterfall = createReactComponent(
  'outline',
  'customChartsWaterfall',
  'CustomChartsWaterfall',
  [
    [
      'path',
      {
        key: 'customChartsWaterfall-path-1',
        d: 'M3,3v18h18M8.4,6v10.8M16.4,9.8v4.6M12.4,12v4.8M20.4,7.8v4.2',
      },
    ],
  ]
);
